import { useContext } from 'react';
import { CustomerAdminContext } from '../providers/CustomerAdminStateProvider';

export const useCustomerAdminState = () => {
  return useContext(CustomerAdminContext);
};
